import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M23.014 28.028h-1.5v2h1.5v-2Z"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.999 2h24.002v7h-1.994l-1.983 16.302 1.97 10.695H38v2L2 38v-2h2.187l2.09-4.141L4.005 9.001H2V2h6.006l2.981 1.317L14 2Zm19.993 7-1.813 14.905-1.334-.686v-1.26h-2v2.481l3.3 1.695 1.816 9.862h-6.777l-1.457-5.086 1.298-11.41-12.99 1.35 2.815 7.085L15.266 36H6.427l1.736-3.439 2.407-.825 1.842 1.261 1.13-1.65-1.503-1.029.69-1.235-1.746-.975-.948 1.698-1.888.646-2.132-21.45h3.482l3.935 5.519-.57 1.713 1.899.63.557-1.677 3.08-.79 1.878 1.299 1.138-1.645-2.628-1.818-3.829.982-3.004-4.213h15.053L30 7.692l3.002 1.309h.989Zm-8.888 26.998h-7.8l1.622-8.253-2.057-5.177 7.888-.82-1.063 9.331 1.41 4.919ZM14.417 4l-3.434 1.501L7.583 4H4v3h22.588L30 5.51 33.42 7H36V4H14.418Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var PictogramBuildingEmergencyHouse40 = createIcon(IconComponent);